module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_8019.5cba3b9f.png";